/* eslint-disable react/prop-types */
import { useState } from 'react';
import { getGameAnalyticsRoute } from '../../../../route/navigate';
import { formatDate } from '../../../../utils/DateFormat';
import EditIcon from '../../../../assets/svg/Edit.svg';
import CreateGameModal from '../../Modal/GameModal/CreateGameModal';
import usePermission from '../../../../hooks/usePermision';

export const gameColumn = [
  {
    Header: ' ',
    columns: [
      {
        Header: 'Id',
        accessor: '_id',
        Cell: ({ row }) => (
          <a
            href={getGameAnalyticsRoute(row.values._id)}
            className="text-[#11B954] body-2 cursor-pointer"
            target="_blank"
            rel="noreferrer"
          >
            {row.values._id}
          </a>
        ),
      },
      {
        Header: 'Name',
        accessor: 'name',
      },

      {
        Header: 'Type',
        accessor: 'type',
      },
      {
        Header: 'Create At',
        accessor: 'createdAt',
        Cell: ({ row }) => {
          return (
            <>
              <div>{formatDate(row.values.createdAt)}</div>
            </>
          );
        },
      },
      {
        Header: 'Action',
        accessor: 'action',
        Cell: ({ row }) => {
          const [isModal, setIsModal] = useState(false);
          const [hasAccess] = usePermission();

          const onToggleModal = () => {
            setIsModal(!isModal);
          };

          return (
            <div className="">
              {hasAccess && (
                <>
                  <img
                    id={row.values._id}
                    src={EditIcon}
                    alt=""
                    onClick={() => onToggleModal()}
                    className="w-8 p-1 hover:bg-[#dadbe6] bg-[#F4F5FF] rounded-full cursor-pointer"
                  />
                  {isModal && (
                    <CreateGameModal
                      isModalOpen={isModal}
                      onToggleModal={onToggleModal}
                      gameId={row.original._id}
                      actionType="UPDATE"
                    />
                  )}
                </>
              )}
            </div>
          );
        },
      },
    ],
  },
];
